import request from '@/utils/request'

export function selectMaterialType(data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: `api/serviceCenter/stainlessSteelFile/selectMaterialType`,
        method: 'post',
        data,
    })
}

export function stainlessSteelSelectInfo(currentPage,pageSize,data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: `api/serviceCenter/stainlessSteelFile/stainlessSteelSelectInfo?size=${pageSize}&current=${currentPage}`,
        method: 'post',
        data,
    })
}

export function stainlessSteelBatchDelete(data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: `api/serviceCenter/stainlessSteelFile/stainlessSteelBatchDelete?`,
        method: 'post',
        data,
    })
}

export function updateComposition(data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: `api/serviceCenter/stainlessSteelFile/updateComposition?`,
        method: 'post',
        data,
    })
}

export function updateUnComposition(data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: `api/serviceCenter/stainlessSteelFile/updateUnComposition?`,
        method: 'post',
        data,
    })
}

export function unDownLoad(data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: `api/serviceCenter/stainlessSteelFile/unDownLoad?`,
        method: 'post',
        data,
    })
}
